<template>

    <div>
        <div v-if="_.isEmpty(summaryData)">
            <h1>Shrnutí rezervace není možné zobrazit</h1>
            <p>Je nám líto, ale není možné zobrazit shrnutí rezervace, protože žádná rezervace nebyla zadána.</p>
            <b-button variant="success" class="float-right" to="/">Další rezervace</b-button>
        </div>
        <div v-else>
            <h1>Vaše rezervace byla úspěšně odeslána</h1>
            <p>Na Vámi zadaný email bude zaslaná zpráva se shrnutím rezervace.</p>
            <div class="row">
                <div class="col-md-8">
                    <h5>Osobní údaje</h5>
                    <p>
                        <span>Lékárna:</span> <strong>{{summaryData.businessPremiseText}}</strong><br />
                        <span>Jméno a příjmení:</span> <strong>{{summaryData.fullName}}</strong><br />
                        <span>Email:</span> <strong>{{summaryData.email}}</strong><br />
                        <span>Telefon:</span> <strong>{{summaryData.phoneNumber}}</strong><br />
                    </p>
                    <p v-if="hasPrescription">Možnost zaměnit léky za levnější generika: <strong>{{summaryData.allowChangeMedicamentForCheaper == true? 'Ano' : 'Ne'}}</strong></p>
                    <p v-if="hasPrescription">Vydat všechna opakování u opakovacích eReceptů: <strong>{{summaryData.allowReleaseAllReps == true? 'Ano' : 'Ne'}}</strong></p>
                    <span :if="summaryData.note && summaryData.note.length > 0">Poznámka:</span> <strong>{{summaryData.note}}</strong>
                </div>
                <div class="col-md-4">
                    <div>
                        <h5>eRecepty</h5>
                        <p>
                            <span v-for="item in summaryData.prescriptions" :key="item.id">{{item.code | ereceiptCode}}<br /></span>
                        </p>
                    </div>
                    <div>
                        <h5>ePoukazy</h5>
                        <p>
                            <span v-for="item in summaryData.vouchers" :key="item.id">{{item.code}}<br /></span>
                        </p>
                    </div>
                </div>
            </div>
            <b-button variant="success" class="float-right" v-on:click="$router.go(-1)">Další rezervace</b-button>
        </div>
    </div>

</template>

<script>

    export default {
        name: 'orderSummary',
        data: function () {
            return {
                summaryData: {}
            }
        },
        props: {
        },
        computed: {
            hasPrescription() {
                return this.summaryData.prescriptions && this.summaryData.prescriptions.length > 0;
            }
        },
        mounted() {
            this.summaryData = this.$store.state.reservation.createReservation.createdReservation;
        }
    }

</script>